export enum AnnotationStatus {
  None = 0,
  HasPdf = 1,
  HasImages = 2,
  ImagesCreationRequested = 4,
  ImagesProcessing = 8,
  PdfCreationRequested = 16,
  PdfProcessing = 32,
  Processing = ImagesCreationRequested | ImagesProcessing | PdfCreationRequested | PdfProcessing,
  Unknown
}
